// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.no-data-state-container[data-v-16d52987] {\n  min-height: 29vh;\n}\n.no-data-state-container h5[data-v-16d52987] {\n  font-size: 1.1rem !important;\n  opacity: 0.4;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
